import { BLISS_DEPOSIT_POLICY } from './blissDepositPolicy'
/** Design services & quote approval terms shown on client quote documents. */

export const BLISS_DESIGN_SERVICES_TERMS = {
  title: 'Design Services Terms',
  sections: [
    {
      heading: 'Room Consultation ($149)',
      body:
        'The Bliss Room Consultation is a paid design conversation about your room, sleeping goals, and layout. The full $149 fee is credited dollar-for-dollar toward your Bliss Design Only Service or your fabrication deposit when you move forward under these terms. No fabrication obligation is created by the consultation alone.',
    },
    {
      heading: 'Design Only Service',
      body:
        'Design Only is priced individually on your proposal and includes custom room design, complete parts lists and complete cut lists. Pay securely, then schedule your Design Kickoff. Fabrication and installation are not included. Paying for design does not obligate you to purchase a Bliss build. If you build with Bliss, the paid design fee is credited against your final balance.',
    },
    {
      heading: 'Fabrication deposit',
      body:
        BLISS_DEPOSIT_POLICY.paragraphs.join(' ') + ' The separately purchased Design Only Service is governed by its own terms above. Any verified $149 Room Consultation credit is deducted from your deposit due.',
    },
    {
      heading: 'Payment methods',
      body:
        'Design consultations and the Design Only Service can be paid by card. Fabrication deposits are paid from your bank (ACH) or by wire. Your final balance before delivery is paid by sending a bank transfer — Stripe online instructions or wire to Bliss — so we can confirm delivery scheduling.',
    },
    {
      heading: 'Estimates & changes',
      body:
        'Quoted build totals are estimates based on specifications at the time of this document. Final pricing is confirmed during design. Changes to materials, dimensions, hardware, or scope may change the investment. Your remaining balance is due after your build is complete and before delivery and installation.',
    },
  ],
} as const
